export default "__VITE_ASSET__YuS5pRN5__"